import { Phone, X } from "lucide-react";
import { eventPopupImage } from "@/constants/nossaData";

export const EventPromoPopup = ({ onClose }) => (
  <div className="event-popup-backdrop" data-testid="event-popup-backdrop" role="dialog" aria-modal="true" aria-label="Final del mundial en Nossa">
    <div className="event-popup-card" data-testid="event-popup-card">
      <button className="event-popup-close" onClick={onClose} data-testid="event-popup-close-button" aria-label="Cerrar promoción">
        <X size={22} />
      </button>
      <img src={eventPopupImage} alt="Final del mundial España contra Argentina en Nossa" data-testid="event-popup-image" />
      <div className="event-popup-actions">
        <a
          href="https://wa.me/34680502341?text=Hola%20Nossa%2C%20quiero%20reservar%20mesa%20para%20ver%20la%20final%20del%20mundial"
          target="_blank"
          rel="noreferrer"
          data-testid="event-popup-whatsapp-button"
        >
          Reservar mesa <Phone size={18} />
        </a>
        <button onClick={onClose} data-testid="event-popup-later-button">Ver la web</button>
      </div>
    </div>
  </div>
);